import {environment} from "../../../environments/environment";
import {FuncionesExterno} from "../../externo/funciones-Externo";
import {HttpClient} from "@angular/common/http";

export class Observaciones {

  public static getObservaciones(http: HttpClient, parametros: any) {

    // Se añade bearer token al header
    const headers = { 'Authorization': 'Bearer ' + FuncionesExterno.getToken() };

    return new Promise<any>((resolve, reject) =>
    {
      http.post<any[]>(environment.logisticaWSBase + "/PetTallHoja/getComentarioAccessToken", parametros,  { headers } )
        .subscribe
        ({
          next(res)
          {
            resolve(res);
          },
          error(err)
          {
            console.error(err);
            reject(err);
          },
        })
    });

  }
}
